import { useField } from 'remix-validated-form';
import { cn } from '@cardo/lib';
import type { ChangeEvent } from 'react';

type CheckboxProps = {
  name: string;
  label?: React.ReactNode | null;
  className?: string;
  containerClassName?: string;
  defaultValue?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  checked?: boolean;
};

export function Checkbox({
  name,
  label,
  className,
  containerClassName,
  defaultValue,
  onChange,
  value,
  checked,
}: CheckboxProps) {
  const { error, getInputProps } = useField(name);
  return (
    <div className={cn('flex flex-col', containerClassName)}>
      <label
        htmlFor={name}
        className={cn(
          'flex gap-2 cursor-pointer items-center',
          label && 'flex w-full items-start gap-3',
          className,
        )}
      >
        <input
          type="checkbox"
          {...getInputProps({ id: name })}
          className={cn(
            'rounded w-6 h-6 border-gray-500 cursor-pointer',
            label && 'mt-1',
          )}
          defaultValue={defaultValue || undefined}
          onChange={onChange}
          value={value}
          checked={checked}
        />
        {label && <div className="flex flex-grow">{label}</div>}
      </label>
      {!error && <p className="h-7"></p>}
      {error && (
        <p className="text-sm text-rose-600 my-1 whitespace-wrap">{error}</p>
      )}
    </div>
  );
}
